import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { GenericPageHeader } from '../../../sharedLayout/pageheader'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, FolderPage, Page } from '../../cmsPageState'
import { FoldersLayout } from './folderPageLayout'
import { SearchablePatientFolder } from '../../../../backendApi/generated'
import i18next from 'i18next'

export const folderPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: FolderPage): Widget<Updater<Page>> =>
    any([
      async<SearchablePatientFolder>(page.folderContent).map(cmsPageStateUpdaters.folderContentUpdater),
      fromJSX((setState) => {
        if (page.folderContent.kind !== "loaded") return <></>
        return <GenericPageHeader
          kind="folders"
          title={page.folderContent.value.Titel ? page.folderContent.value.Titel
            : page.folderContent.value.Title ? page.folderContent.value.Title
            : page.title}
          intro={page.folderContent.value.Subtitel ? page.folderContent.value.Subtitel
            : page.intro}
          breadcrumbs={[
            { title: 'Folders', url: '/folders' },
            { title: page.title, url: page.url },
          ]}
          quickUtils={{
            downloadLink: page.folderContent.value.Path ?? "",
            shareLabel: i18next.t("folder:ShareLabel"),
            isDropdownOpen: page.quickUtilsState!.isDropdownOpen,
            copyCompleted: page.quickUtilsState!.copyCompleted,
            pageTitle: page.title,
            onDropdownToggle: () => setState(cmsPageStateUpdaters.shareOptionsToggleUpdater),
            onDropdownClose: () => setState(cmsPageStateUpdaters.shareOptionsCloseUpdater),
            onCopy: () => setState(cmsPageStateUpdaters.onCopyUpdater),
          }}
        />
      }),

      fromJSX((setState) => {
        if (page.folderContent.kind !== "loaded") return <></>
        return <FoldersLayout
          folderHtml={page.folderContent.value.HTML ?? ""}
          folderDetails={{
            lastModified: page.folderContent.value.PublicatieDatum ?? new Date(),
            folderNumber: page.folderContent.value.DocumentNumber ?? "",
          }}
          sideMenu={{
            isOpen: page.sideMenu.isOpen,
            activeHeaderId: page.sideMenu.activeHeaderId,
            toggle: () => setState(cmsPageStateUpdaters.folderMenuToggleUpdater),
            close: () => setState(cmsPageStateUpdaters.folderMenuCloseUpdater),
            setActiveHeader: (activeHeaderId?: string) =>
              setState(cmsPageStateUpdaters.folderMenuActiveHeaderUpdater(activeHeaderId)),
          }}
        />
      }),

      blocksWidget(acceptVideoCookie)(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
